import React from "react";

import "./CartHeader.scss";

const CartHeaderComponent = () => (
  <h2 className="cart-header">Detalle del pedido</h2>
);

export default CartHeaderComponent;
